import React, { useEffect, useState } from "react";
import { Pagination as BSPagination } from "react-bootstrap";

interface PaginationProps {
  totalItems?: number;
  itemsCountPerPage?: number;
  className?: string;
  changePage: any;
  changeCurrentPage?: any;
}

const Pagination = (props: PaginationProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(0);
  const [pages, setPages] = useState<Number[]>([]);

  useEffect(() => {
    setCurrentPage(props.changeCurrentPage);
  }, [props.changeCurrentPage]);

  useEffect(() => {
    var totalItems: number = props.totalItems ? props.totalItems : Number(10);
    var itemsCountPerPage: number = props.itemsCountPerPage
      ? props.itemsCountPerPage
      : Number(10);
    const totalPage = Math.ceil(totalItems / itemsCountPerPage);
    setLastPage(totalPage);
    var temp = [];
    temp.push(currentPage);
    setPages(temp);
  }, [currentPage, props.totalItems]);

  const changepage = (page: number) => {
    setCurrentPage(page);
    props.changePage(page);
  };

  const nextchangepage = () => {
    setCurrentPage(currentPage == lastPage ? lastPage : currentPage + 1);
    props.changePage(currentPage == lastPage ? lastPage : currentPage + 1);
  };
  const previouschangepage = () => {
    setCurrentPage(currentPage == 1 ? currentPage : currentPage - 1);
    props.changePage(currentPage == 1 ? currentPage : currentPage - 1);
  };

  const onLastPage = () => {
    if (currentPage < lastPage) {
      changepage(lastPage);
    }
  };

  const onFirstPage = () => {
    if (currentPage > 1) {
      changepage(1);
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mt-3">
        {/* <div className="gridjs-summary mt-0 px-2" title="Total Count">
          Total Count : {props.totalItems}
        </div> */}
        {/* <div className="gridjs-pages">
          <nav className="" aria-label="pagination"> */}
            {/* <ul className="pagination"> */}{" "}
            <BSPagination>
              {/* <li className="arrow-box paginatin-btn pagination-item">
                <span className="page-link cursor-pointer" aria-label="First" onClick={() =>{onFirstPage()}}>
                  <span aria-hidden="true">«</span>
                  <span className="visually-hidden">First</span>
                </span>
              </li> */}
              <BSPagination.First onClick={onFirstPage} />
              {/* <li
                className="arrow-box paginatin-btn pagination-item"
                onClick={() => previouschangepage()}
              >
                <span className="page-link cursor-pointer" aria-label="Previous">
                  <span aria-hidden="true">‹</span>
                  <span className="visually-hidden">Previous</span>
                </span>
              </li> */}
              <BSPagination.Prev onClick={previouschangepage} />
              {pages.map((page: any, index: number) => {
                return (
                  <BSPagination.Item
                    key={"pagable_" + index}
                    active={
                      page == currentPage
                       
                    }
                    onClick={() => changepage(page)}
                  >
                    {/* <span className="active page-link cursor-pointer"> */}
                      {page}
                    {/* </span> */}
                  </BSPagination.Item>
                );
              })}
              {currentPage < lastPage ? (
                <>
                  <BSPagination.Next onClick={nextchangepage} />
                  {/* <li
                    onClick={() => {
                      nextchangepage()
                    }}
                    className="arrow-box paginatin-btn pagination-item"
                  >
                    <span className="page-link cursor-pointer" aria-label="Next" >
                      <span aria-hidden="true">›</span>
                      <span className="visually-hidden">Next</span>
                    </span>
                  </li> */}
                  {/* <li className="arrow-box paginatin-btn pagination-item">
                    <span className="page-link cursor-pointer" aria-label="Last" onClick={() =>{onLastPage()}}>
                      <span aria-hidden="true">»</span>
                      <span className="visually-hidden">Last</span>
                    </span>
                  </li> */}
                  <BSPagination.Last onClick={onLastPage} />
                </>
              ) : (
                ""
              )}
              {/* </ul> */}{" "}
            </BSPagination>
          {/* </nav>
        </div> */}
      </div>
    </>
  );
};

export default Pagination;
